const PLACEHOLDER = /\{(\w+)\}/g

export function fillTemplate (template, values) {
  return template.replace(PLACEHOLDER, (placeholder, key) => (key in values ? String(values[key]) : placeholder))
}
